var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "bg-cl-transparent brdr-none inline-flex",
      attrs: {
        type: "button",
        "aria-label": _vm.$t("Open search panel"),
        "data-testid": "openSearchPanel"
      },
      on: { click: _vm.toggleSearchpanel }
    },
    [_c("i", { staticClass: "material-icons" }, [_vm._v("search")])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }